import { use, useEffect, useState } from "react";

import { useDataStore } from "@store/user_org";
import { useConfigStore } from "@store/persist";

import SettingBar from "@navigation/SettingBar";
import { Account } from "./settings/Account";
import { Company } from "./settings/Company";
import { Team } from "./settings/Team";
import { EmailTemplates } from "./settings/EmailTemplates";
import { Library } from "./settings/Library";
import { ProjectTemplates } from "./settings/ProjectTemplates";
import { FormTemplates } from "./settings/FormTemplates";
import { PlanningTemplates } from "./settings/PlanningTemplates";
import { SyncOperations } from "./settings/SyncOperations";
import { EmailDesigns } from "./settings/EmailDesigns";
import InboxScreen from "./InboxScreen";
import NotificationsScreen from "./NotificationsScreen";
import { Users } from "./settings/Users";
import { InvitationsMonitor } from "./settings/InvitationsMonitor";
import { AlgoliaRecords } from "./settings/AlgoliaRecords";
import { Automatismes } from "./settings/Automatismes";
import { BillingTemplates } from "./settings/BillingTemplates";
import { useParams, useSearchParams } from "react-router-dom";

export default function SettingsScreen() {
  const [searchParams] = useSearchParams();
  const orgData = useDataStore((state) => state.orgData);
  const prefix = useConfigStore((state) => state.prefix);

  const [page, setPage] = useState<string>(
    searchParams.get("page") || "account",
  );

  useEffect(() => {
    setPage(searchParams.get("page") || "account");
  }, [searchParams]);

  return (
    <div className="flex flex-row max-h-full w-full max-w-full h-screen">
      <SettingBar page={page} setPage={setPage}></SettingBar>
      <div className="flex flex-col w-full h-full overflow-auto">
        <div className="flex flex-col h-full">
          {page === "account" && <Account></Account>}{" "}
          {page === "company" && <Company></Company>}{" "}
          {page === "team" && <Team></Team>}{" "}
          {page === "email-templates" && <EmailTemplates></EmailTemplates>}
          {page === "library" && <Library />}
          {page === "project-templates" && <ProjectTemplates />}
          {page === "form-templates" && <FormTemplates />}
          {page === "planning-templates" && <PlanningTemplates />}
          {page === "sync-operations" && <SyncOperations />}
          {page === "email-designs" && <EmailDesigns />}
          {(page === "notifications" || page === "emails-sent") && <NotificationsScreen />}
          {page === "inbox" && <InboxScreen />}
          {page === "automatismes" && <Automatismes />}
          {page === "users" && <Users />}
          {page === "invitations" && <InvitationsMonitor />}
          {page === "algolia-records" && <AlgoliaRecords />}
          {page === "billing-templates" && <BillingTemplates />}
        </div>
      </div>
    </div>
  );
}
